import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const ContainerDataContract = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export const ContainerCard = styled.div`
    padding: 70px 16px 0;
    background-color: transparent;
`;

export const ContractNumber = styled.div`
    color: ${(props) => props.theme.blackLink};
    font-size: ${theme.font.size16};
    font-weight: bold;
`;

export const ContractName = styled.div`
    width:220px;
    color: ${(props) => props.theme.greyLink};
    font-size: ${theme.font.size14};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    margin: auto 24px;
    margin-left: 0;
`;

export const StyledButton = styled.div`
    width: 49%;
    max-width: 404px;

    @media (max-width: 560px) {
       width: 100%;
    }
`;

export const ContainerButton = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin: 24px 0 0 0;

    & button {
        width: 176px;
    }
`;
